var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LocaleAwareBaseComponent } from './../../../common-theme/seo/locale-aware-base.component';
var ContactUsComponent = /** @class */ (function (_super) {
    __extends(ContactUsComponent, _super);
    function ContactUsComponent() {
        return _super.call(this) || this;
    }
    return ContactUsComponent;
}(LocaleAwareBaseComponent));
export { ContactUsComponent };



// WEBPACK FOOTER //
// ./src/app/shared/components/contact-us/contact-us.component.ts.pre-build-optimizer.js